module.exports = __webpack_public_path__ + "img/garage-arbor.b06e5a9b.webp";